if (!customElements.get('collection-subcategories')) {
  class CollectionSubcategories extends HTMLElement {
    constructor() {
      super();

      this.row = this.querySelector('[data-subcategories-row]');
      this.prevButton = this.querySelector('[data-subcategories-prev]');
      this.nextButton = this.querySelector('[data-subcategories-next]');
      this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');

      this.onPrevClick = this.onPrevClick.bind(this);
      this.onNextClick = this.onNextClick.bind(this);
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      if (!this.row || !this.prevButton || !this.nextButton) return;

      this.prevButton.addEventListener('click', this.onPrevClick);
      this.nextButton.addEventListener('click', this.onNextClick);
      this.row.addEventListener('scroll', this.onScroll, { passive: true });
      this.mobileMediaQuery.addEventListener('change', this.onResize);
      window.addEventListener('resize', this.onResize);

      this.updateButtons();
    }

    disconnectedCallback() {
      this.prevButton?.removeEventListener('click', this.onPrevClick);
      this.nextButton?.removeEventListener('click', this.onNextClick);
      this.row?.removeEventListener('scroll', this.onScroll);
      this.mobileMediaQuery.removeEventListener('change', this.onResize);
      window.removeEventListener('resize', this.onResize);
    }

    onPrevClick() {
      this.scrollByDirection(-1);
    }

    onNextClick() {
      this.scrollByDirection(1);
    }

    onScroll() {
      this.updateButtons();
    }

    onResize() {
      this.updateButtons();
    }

    scrollByDirection(direction) {
      const firstItem = this.row.querySelector('.collection-subcategories__item');
      if (!firstItem) return;

      const rowStyles = window.getComputedStyle(this.row);
      const gap = parseFloat(rowStyles.columnGap || rowStyles.gap || '0') || 0;
      const scrollAmount = firstItem.offsetWidth + gap;

      this.row.scrollBy({
        left: direction * scrollAmount,
        behavior: 'smooth'
      });
    }

    updateButtons() {
      const isMobile = this.mobileMediaQuery.matches;
      const hasOverflow = this.row.scrollWidth > this.row.clientWidth + 1;

      this.classList.toggle('is-scrollable', isMobile && hasOverflow);

      if (!isMobile || !hasOverflow) {
        this.prevButton.disabled = true;
        this.nextButton.disabled = true;
        return;
      }

      const maxScrollLeft = this.row.scrollWidth - this.row.clientWidth;
      this.prevButton.disabled = this.row.scrollLeft <= 1;
      this.nextButton.disabled = this.row.scrollLeft >= maxScrollLeft - 1;
    }
  }

  customElements.define('collection-subcategories', CollectionSubcategories);
}
